// API配置
export default {
  // 获取API基础URL
  getBaseUrl() {
    return process.env.NODE_ENV === 'development'
      ? '/' // 使用根路径，避免相对路径问题
      : window.location.origin
  },
  
  // 获取API完整URL
  getApiUrl(endpoint) {
    const baseUrl = this.getBaseUrl()
    return `${baseUrl}/api${endpoint}`
  }
}